// extracted by mini-css-extract-plugin
export var bottomPosition = "BookingBanner-module--bottom-position--b5dc2";
export var cta = "BookingBanner-module--cta--f4983";
export var root = "BookingBanner-module--root--b4b15";
export var slideBottom = "BookingBanner-module--slide-bottom--604e8";
export var slideTop = "BookingBanner-module--slide-top--4aa81";
export var subTitle = "BookingBanner-module--subTitle--7dfaa";
export var text = "BookingBanner-module--text--35362";
export var title = "BookingBanner-module--title--b9f8d";
export var topPosition = "BookingBanner-module--top-position--5cedb";
export var visible = "BookingBanner-module--visible--52655";